// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__G_ela","title":"styles_title__QyEMj","image":"styles_image__zR7NF","subtitle":"styles_subtitle__wxHDb","description":"styles_description__YToc_"};